import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import "./RobotMaster.css";
import toast from "react-hot-toast";

export default function RobatMaster() {
  const [robotList, setRobotList] = useState([]);
  const [robotName, setRobotName] = useState("");
  const [category, setCategory] = useState("");
  const [editRobot, setEditRobot] = useState(null);
  const [editName, setEditName] = useState("");
  const [editCategory, setEditCategory] = useState("");
  const [editStatus, setEditStatus] = useState("ACTIVE");
  const [addStatus, setAddStatus] = useState("ACTIVE");

  const [viewMode, setViewMode] = useState("LIST");

  const API_BASE_URL = "https://prodapi.iworkkz.com:9095";
  const API_KEY = "X4gfacRza++DrL%2FqFYkhZJAuiuuJEsGwmfJz7tZHGi4%3D";

  // ✅ FETCH API DATA (API KEY IN QUERY PARAM)
  useEffect(() => {
    const url = `${API_BASE_URL}/API/Robots/getRobotList?key=${API_KEY}`;

    fetch(url, {
      method: "GET",
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("API request failed");
        }
        return res.json();
      })
      .then((data) => setRobotList(data))
      .catch((err) => console.error("API Error:", err.message));
  }, []);

  const handleSave = () => {
    if (!robotName.trim()) {
      toast.warning("Please enter robot name");
      return;
    }

    const newRobot = {
      name: robotName,
      STATUS: addStatus,
      category: category,
    };

    const url = `${API_BASE_URL}/API/Robots/CreateRobot?key=${API_KEY}`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRobot),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Save failed");
        return res.json();
      })
      .then((data) => {
        /**
       ✅ Your API returns:
       { id: 17, name: "rr", message: "Robot inserted successfully." }
      */

        // ✅ CONVERT API RESPONSE TO TABLE FORMAT
        const formattedRobot = {
          ID: data.id,
          NAME: data.name,
          STATUS: addStatus,
          CATEGORY: category, // ✅ FIX ADDED
        };

        setRobotList((prev) => [formattedRobot, ...prev]);

        // ✅ RESET FORM
        setRobotName("");
        setCategory("");
        setAddStatus("ACTIVE");
        setViewMode("LIST");

        // ✅ SUCCESS TOASTER
        toast.success(`Robot "${data.name}" added successfully`);
      })
      .catch((err) => {
        console.error("Save Error:", err.message);
        toast.error("Failed to save robot", err.message);
      });
  };

  const handleEdit = (robot) => {
    setEditRobot(robot);
    setEditName(robot.NAME);
    setEditStatus(robot.STATUS);
    setEditCategory(robot.CATEGORY);
    setViewMode("EDIT");
  };

  const handleUpdate = () => {
    if (!editName.trim()) {
      toast.warning("Please enter robot name");
      return;
    }

    const url = `${API_BASE_URL}/API/Robots/name?key=${API_KEY}&id=${editRobot.ID}`;

    fetch(url, {
      method: "PATCH", // or PUT based on your backend
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: editName,
        STATUS: editStatus,
        category: editCategory,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Update failed");
        return res.json();
      })
      .then(() => {
        // ✅ Update UI instantly (ID remains unchanged)
        setRobotList((prev) =>
          prev.map((item) =>
            item.ID === editRobot.ID
              ? { ...item, NAME: editName, STATUS: editStatus }
              : item
          )
        );

        setViewMode("LIST");
        setEditRobot(null);

        toast.success("Robot updated successfully ✅");
      })
      .catch((err) => {
        console.error("Update Error:", err.message);
        toast.error("Failed to update robot ❌");
      });
  };

  const handleStatusToggle = (robot) => {
    const newStatus = robot.STATUS === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    const url = `${API_BASE_URL}/API/Robots/status?key=${API_KEY}&id=${robot.ID}`;

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        STATUS: newStatus,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Status update failed");
        return res.json();
      })
      .then(() => {
        // ✅ Update UI instantly
        setRobotList((prev) =>
          prev.map((item) =>
            item.ID === robot.ID ? { ...item, STATUS: newStatus } : item
          )
        );
      })
      .catch((err) => {
        console.error("Status Error:", err.message);
        alert("Failed to update status");
      });
  };

  return (
    <>
      <Navbar />

      <div className="Pagename">
        <div>Robot Master</div>
      </div>

      <div className="Secondbar">
        {viewMode !== "LIST" && (
          <button
            className="back-circle-btn"
            onClick={() => setViewMode("LIST")}
            title="Back"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
        )}
        {viewMode === "LIST" && (
          <button
            className="plus-btn"
            onClick={() => {
              setViewMode("ADD");
              setRobotName("");
            }}
          >
            + Add Robot
          </button>
        )}
      </div>

      {viewMode === "LIST" && (
        <div className="table-container">
          <table className="robot-table">
            <thead>
              <tr>
                <td>ID</td>
                <td>Robot Name</td>
                <td>Category</td>
                <td>Status</td>
                <td>Action</td>
              </tr>
            </thead>

            <tbody>
              {robotList.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No data found
                  </td>
                </tr>
              ) : (
                robotList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.ID}</td>
                    <td>{item.NAME}</td>
                    <td>{item.CATEGORY}</td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item.STATUS === "ACTIVE"}
                          onChange={() => handleStatusToggle(item)}
                        />
                        <span className="slider"></span>
                      </label>
                    </td>
                    <td className="action-col">
                      <i
                        className="fa-regular fa-pen-to-square fa-lg edit-icon"
                        onClick={() => handleEdit(item)}
                        title="Edit Robot"
                      ></i>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {viewMode === "ADD" && (
        <div className="addview">
          <h4>Add Robot</h4>

          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label>Name</label>
            <input
              type="text"
              placeholder="Enter robot name"
              value={robotName}
              onChange={(e) => setRobotName(e.target.value)}
            />
          </div>

          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label>Category</label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              <option value="Greeting">Greeting</option>
              <option value="Cleaning">Cleaning</option>
              <option value="Delivery">Delivery</option>
            </select>
          </div>

          {/* ✅ STATUS TOGGLE (SAME AS EDIT) */}
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <span>Status</span>

            <label className="switch">
              <input
                type="checkbox"
                checked={addStatus === "ACTIVE"}
                onChange={() =>
                  setAddStatus(addStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE")
                }
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="popup-buttons">
            <button className="btn-save" onClick={handleSave}>
              Save
            </button>
            <button
              className="btn-cancel"
              onClick={() => {
                setRobotName("");
                setCategory("");
                setAddStatus("ACTIVE");
                setViewMode("LIST");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {viewMode === "EDIT" && (
        <div className="addview">
          <h4>Edit Robot</h4>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span>Name</span>
            <input
              type="text"
              placeholder="Enter robot name"
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
            />
          </div>

          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span>Category</span>
            <select
              value={editCategory}
              onChange={(e) => setEditCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              <option value="Greeting">Greeting</option>
              <option value="Cleaning">Cleaning</option>
              <option value="Delivery">Delivery</option>
            </select>
          </div>

          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <span>Status</span>

            <label className="switch">
              <input
                type="checkbox"
                checked={editStatus === "ACTIVE"}
                onChange={() =>
                  setEditStatus(editStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE")
                }
              />
              <span className="slider"></span>
            </label>
          </div>

          <div className="popup-buttons">
            <button className="btn-save" onClick={handleUpdate}>
              Update
            </button>

            <button
              className="btn-cancel"
              onClick={() => {
                setViewMode("LIST");
                setEditRobot(null);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}
